(function(c,w,v){function getUrlParameter(e){var t=new RegExp("[\?&]"+e+"=([^&#]*)").exec(location.search);return null===t?"":decodeURIComponent(t[1].replace(/\+/g," "))}function setCookie(e,t){var r,n=w.location.host,a=n.substring(n.indexOf("."));(a.match(/\./g).length<2||".co"===a.substring(0,a.indexOf(".",1)))&&(a="."+n),r='domain='+a;var i=new Date,o=i.getTime()+31536e6;i.setTime(o);var c="expires="+i.toUTCString();v.cookie = e + "=" + t + ";" + c + ";" + r + ";path=/;SameSite=none;Secure"}var tdclid_sn=getUrlParameter("tdclid_sn");tdclid_sn&&setCookie("tdclid_sn",tdclid_sn);var q='?org='+c.organization+'&prog='+c.programId;w.tdfallback=function(e){var t,r=v.getElementsByTagName("script")[0];(t=v.createElement("script")).src=e+q,r.parentNode.insertBefore(t,r)};
(function(i,s,o,g,r,a,m){i.TDConversionObject=r;i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)})(window,document,'script', 'https://sdk.tradedoubler.com/trsdk'+q, 'tdconv'); tdconv('init',c);
})({organization: '2442161', programId: '381866', program: false, element: 'iframe'}, window, document);

(function () {
  if (!window.Shopify?.loadFeatures) return;

  Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
    if (error) return;
    if (!Shopify.customerPrivacy) return;

    tryLoadTags();

    document.addEventListener('visitorConsentCollected', function (ev) {
      if (ev?.detail?.marketingAllowed) tryLoadTags();
    });

    function tryLoadTags() {
      var hasMarketingConsent = false;
      if (typeof Shopify.customerPrivacy.marketingAllowed === 'function') {
        hasMarketingConsent = !!Shopify.customerPrivacy.marketingAllowed();
      } else if (typeof Shopify.customerPrivacy.currentVisitorConsent === 'function') {
        var c = Shopify.customerPrivacy.currentVisitorConsent() || {};
        hasMarketingConsent = c.marketing === 'yes' || c.marketing === true;
      }

      if (typeof window.tdconv === 'function') {
        try { window.tdconv('tracking-consent', hasMarketingConsent); } catch (e) {}
      }

      if (hasMarketingConsent) {
        addScript('https://swrap.tradedoubler.com/wrap?id=32329', true);
      }
    }

    function addScript(src, asyncFlag) {
      if (document.querySelector('script[src="' + src + '"]')) return;
      var s = document.createElement('script');
      s.src = src;
      if (asyncFlag) s.async = true;
      (document.head || document.documentElement).appendChild(s);
    }
  });
})();

